module.exports = __webpack_public_path__ + "img/pink.7669a398.png";